module.exports = __webpack_public_path__ + "static/media/Travel.aa3d81df.svg";